import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import SkyFrame from '../components/sky/SkyFrame'
import Header from '../components/header'
import Footer from '../components/footer'

import './css/index.scss'

// The sky variant comes from the page component itself, not the URL: Gatsby
// renders the 404 page at /404.html but hydrates it at whatever was typed.
const variantOf = (children) => {
  try {
    const page = React.Children.only(children)
    return (page.type && page.type.skyVariant) || 'band'
  } catch (e) {
    return 'band'
  }
}

const TemplateWrapper = ({ children, location }) => {
  const variant = variantOf(children)
  return (
    <div className="site" data-variant={variant}>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Helmet
        title="Zane Staggs - Full Stack AI Software Engineer | San Francisco"
        link={[
          { rel: 'me', href: 'https://github.com/zanedev' },
          { rel: 'me', href: 'https://linkedin.com/in/zanedeveloper' },
        ]}
        meta={[
          { name: 'description', content: 'Zane Staggs is a Full Stack AI Software Engineer based in San Francisco building production software at Block, TIDAL, Cash App, Square, and Weebly. Specializing in AI-driven development, LLM integrations, Rust, React, and full stack systems.' },
          { property: 'og:title', content: 'Zane Staggs - Full Stack AI Software Engineer' },
          { property: 'og:description', content: 'Full Stack AI Software Engineer based in San Francisco with experience at Block, TIDAL, Cash App, Square, and Weebly.' },
          { property: 'og:image', content: 'https://zanestaggs.com/og-image.png' },
          { property: 'og:image:width', content: '1200' },
          { property: 'og:image:height', content: '630' },
          { property: 'og:url', content: 'https://zanestaggs.com' },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:title', content: 'Zane Staggs - Full Stack AI Software Engineer' },
          { name: 'twitter:description', content: 'Full Stack AI Software Engineer based in San Francisco with experience at Block, TIDAL, Cash App, Square, and Weebly.' },
          { name: 'twitter:image', content: 'https://zanestaggs.com/og-image.png' },
          { name: 'twitter:site', content: '@zanedev' },
        ]}
      />
      <SkyFrame variant={variant} />
      <Header />
      {variant === 'full' ? (
        <>
          <main id="main-content" tabIndex={-1} key={location.pathname} className="page-fade">
            {children}
          </main>
          <Footer />
        </>
      ) : (
        // The dusk lives on this wrapper rather than on main, which is
        // re-created (and fades in) on every navigation.
        <div className="site-body">
          <main id="main-content" tabIndex={-1} key={location.pathname} className="page-fade">
            {children}
          </main>
          <Footer />
        </div>
      )}
    </div>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default TemplateWrapper
